module.exports = __webpack_public_path__ + "img/sea.c44e9638.jpg";